<template>
  <!-- Calculator -->
  <div class="modal fade pos-modal" id="calculator" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="calculator-wrap">
            <div class="p-3">
              <div class="d-flex align-items-center">
                <h3>Calculator</h3>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div>
                <input class="input" type="text" placeholder="0" readonly>
              </div>
            </div>
            <div class="calculator-body d-flex justify-content-between">
              <div class="text-center">
                <button type="button" class="btn btn-clear" @click="clr">C</button>
                <button type="button" class="btn btn-number" @click="dis('7')">7</button>
                <button type="button" class="btn btn-number" @click="dis('4')">4</button>
                <button type="button" class="btn btn-number" @click="dis('1')">1</button>
                <button type="button" class="btn btn-number" @click="dis(',')">,</button>
              </div>
              <div class="text-center">
                <button type="button" class="btn btn-expression" @click="dis('/')">÷</button>
                <button type="button" class="btn btn-number" @click="dis('8')">8</button>
                <button type="button" class="btn btn-number" @click="dis('5')">5</button>
                <button type="button" class="btn btn-number" @click="dis('2')">2</button>
                <button type="button" class="btn btn-number" @click="dis('0')">0</button>
              </div>
              <div class="text-center">
                <button type="button" class="btn btn-expression" @click="dis('%')">%</button>
                <button type="button" class="btn btn-number" @click="dis('9')">9</button>
                <button type="button" class="btn btn-number" @click="dis('6')">6</button>
                <button type="button" class="btn btn-number" @click="dis('3')">3</button>
                <button type="button" class="btn btn-number" @click="dis('.')">.</button>
              </div>
              <div class="text-center">
                <button type="button" class="btn btn-clear" @click="back">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 7v10a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -1.414 -.586l-4.586 -4.586a2 2 0 0 1 0 -2.828l4.586 -4.586a2 2 0 0 1 1.414 -.586h8a2 2 0 0 1 2 2z" />
                    <path d="M12 10l4 4m0 -4l-4 4" />
                  </svg>
                </button>
                <button type="button" class="btn btn-expression" @click="dis('*')">x</button>
                <button type="button" class="btn btn-expression" @click="dis('-')">-</button>
                <button type="button" class="btn btn-expression" @click="dis('+')">+</button>
                <button type="button" class="btn btn-clear" @click="solve">=</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Calculator -->
</template>

<script>
export default {
  name: 'PosCalculatorModal',
  methods: {
    getInput() {
      return this.$el?.querySelector?.('.input') || document.querySelector('#calculator .input');
    },
    dis(val) {
      const input = this.getInput();
      if (!input) return;
      if (input.value === 'Error') input.value = '';
      input.value += val;
    },
    clr() {
      const input = this.getInput();
      if (input) input.value = '';
    },
    back() {
      const input = this.getInput();
      if (!input) return;
      if (input.value === 'Error') {
        input.value = '';
        return;
      }
      input.value = input.value.slice(0, -1);
    },
    solve() {
      const input = this.getInput();
      if (!input) return;
      try {
        const expression = input.value.replace(/,/g, '').replace(/%/g, '/100');
        // eslint-disable-next-line no-new-func
        const result = new Function(`return (${expression})`)();
        input.value = Number.isFinite(result) ? String(result) : 'Error';
      } catch (e) {
        input.value = 'Error';
      }
    },
    resetOnClose() {
      this.clr();
    },
  },
  mounted() {
    this.$el?.addEventListener?.('hidden.bs.modal', this.resetOnClose);
  },
  beforeUnmount() {
    this.$el?.removeEventListener?.('hidden.bs.modal', this.resetOnClose);
  },
};
</script>

<style scoped>
.calculator-wrap .btn-clear svg {
  display: block;
  color: #ffffff;
  stroke: currentColor;
}

.calculator-wrap .calculator-body .btn {
  border: 0;
  box-shadow: none;
}
</style>
